import { API, graphqlOperation } from "aws-amplify";

import { createJobRoleMutation } from "./graphql/mutations";

const createJobRole = (_, input) =>
  API.graphql(graphqlOperation(createJobRoleMutation, { input }));

export default createJobRole;
